import { getCurrentInstance, computed } from 'vue';
import { useStore } from 'vuex';
import Axios, { CtrlApi, ZoneApi } from '@/api';
import { DeviceDefault } from '@/common/constants';

export default function useMobile() {
  const { emitter, mobile, logger } =
    getCurrentInstance().appContext.config.globalProperties;
  const store = useStore();
  const getters = computed(() => store.getters);
  const controllers = computed(
    () => getters.value['home/getLowVersionControllers'],
  );

  const ap_wifi = {
    ssid: DeviceDefault.AP_SSID,
    password: DeviceDefault.AP_PWD,
  };

  const searchWifiList = () => {
    return new Promise((resolve, reject) => {
      let timerId = undefined;

      emitter.on('onSearchResult', (payload) => {
        clearTimeout(timerId);
        emitter.emit('hideLoading');
        emitter.off('onSearchResult');
        if (payload.data) {
          const wifis = JSON.parse(
            decodeURIComponent(window.atob(payload.data)),
          );
          const wifiItems = wifis
            .filter((item) => item.ssid?.length > 0)
            .sort((a, b) => {
              if (a.level > b.level) {
                return -1;
              } else if (a.level < b.level) {
                return 1;
              } else {
                return 0;
              }
            });
          resolve(wifiItems);
        } else {
          resolve([]);
        }
      });

      emitter.emit('showLoading');

      timerId = setTimeout(() => {
        reject('wifi 목록을 조회할 수 없습니다.\n다시 시도해주세요.');
      }, 10000);

      const ret = mobile.searchWifi(
        JSON.stringify({ prefix: '', callback: 'onSearchResult' }),
      );
      if (ret === false) {
        clearTimeout(timerId);
        emitter.emit('hideLoading');
        reject('wifi 검색에 실패했습니다.');
      }
    });
  };

  const getWifiInfo = () => {
    // show loading
    // add event
    return new Promise((resolve, reject) => {
      emitter.on('onGetWifiResult', (payload) => {
        emitter.emit('hideLoading');
        emitter.off('onGetWifiResult');

        logger.log('TransferReceivePage.getWifiInfo => payload : ' + payload);

        let currentWifi = undefined;
        if (payload.data) {
          currentWifi = JSON.parse(
            decodeURIComponent(window.atob(payload.data)),
          );
          logger.log(
            'TransferReceivePage.getWifiInfo => currentWifi : ' +
              JSON.stringify(currentWifi),
          );

          if (!currentWifi) {
            reject('검색 결과가 없습니다.');
            return;
          }

          resolve(currentWifi);
        }
      });

      emitter.emit('showLoading');
      const ret = mobile.getWifiInfo(
        JSON.stringify({ callback: 'onGetWifiResult' }),
      );
      if (ret === false) {
        emitter.emit('hideLoading');
      }
    });
  };

  // 컨트롤러 연결 :
  const connectWifi = (params) => {
    // add event
    return new Promise((resolve, reject) => {
      emitter.on('onConnectResult', (payload) => {
        emitter.emit('hideLoading');
        emitter.off('onConnectResult');

        logger.log(
          `TransferReceivePage.connectWifi => onConnectResult : payload : ${JSON.stringify(
            payload,
          )} `,
        );

        if (payload.result) {
          let decoded = JSON.parse(
            decodeURIComponent(window.atob(payload.data)),
          );
          logger.log(
            `TransferReceivePage.connectWifi => onConnectResult : decoded : ${JSON.stringify(
              decoded,
            )}`,
          );

          if (decoded) {
            if (decoded.message) {
              reject(decoded.message);
              return;
            }
            // connectedController.value = decoded.device
            let arr = decoded.device.serial_no.split('_');
            resolve({
              model: arr[0],
              serial_no: decoded.device.serial_no,
              version: decoded.device.version,
            });
            return;
          }
          reject('연결에 실패하였습니다.');
          return;
        }

        reject('연결에 실패하였습니다.');
      });

      emitter.emit('showLoading');
      mobile.connectWifi(
        JSON.stringify(
          params
            ? {
                ...params,
                callback: 'onConnectResult',
              }
            : {
                ssid: ap_wifi.ssid,
                password: ap_wifi.password,
                bssid: ap_wifi.bssid || undefined,
                callback: 'onConnectResult',
              },
        ),
      );
    });
  };

  const connectTest = (params) => {
    return new Promise((resolve, reject) => {
      emitter.on('onConnectTestResult', (payload) => {
        emitter.off('onConnectTestResult');

        if (payload.result) {
          resolve(true);
          return;
        }

        reject('연결에 실패하였습니다.');
      });

      mobile.connectTest(
        JSON.stringify({
          ...params,
          callback: 'onConnectTestResult',
        }),
      );
    });
  };

  // 컨트롤러 연결 :
  const connectTempWifi = (params) => {
    // add event

    let timeoutId = undefined;

    return new Promise((resolve, reject) => {
      emitter.on('onConnectTempResult', (payload) => {
        emitter.emit('hideLoading');
        emitter.off('onConnectTempResult');
        clearTimeout(timeoutId);

        logger.log(
          `TransferReceivePage.connectWifi => onConnectTempResult : payload : ${JSON.stringify(
            payload,
          )} `,
        );

        if (payload.result) {
          resolve(true);
          return;
        }

        reject('연결에 실패하였습니다.');
      });

      console.log(JSON.stringify(params));

      emitter.emit('showLoading');
      mobile.connectTempWifi(
        JSON.stringify(
          params
            ? {
                ...params,
                callback: 'onConnectTempResult',
              }
            : {
                ssid: ap_wifi.ssid,
                password: ap_wifi.password,
                bssid: ap_wifi.bssid || undefined,
                callback: 'onConnectTempResult',
              },
        ),
      );

      timeoutId = setTimeout(() => {
        emitter.emit('hideLoading');
        emitter.off('onConnectTempResult');
        clearTimeout(timeoutId);
        reject('연결에 실패하였습니다.');
      }, 10000);
    });
  };

  // 컨트롤러 설정 :
  const settingController = (settingParams, controllerId) => {
    return new Promise((resolve, reject) => {
      emitter.on('onSettingResult', (payload) => {
        emitter.emit('hideLoading');
        emitter.off('onSettingResult');

        logger.log(
          `TransferReceivePage.settingController => onSettingResult : payload : ${JSON.stringify(
            payload,
          )}`,
        );
        // if (payload.result) {
        mobile.disConnectWifi(JSON.stringify(ap_wifi));
        resolve();
        return;
        // } else {
        //   let decoded = JSON.parse(
        //     decodeURIComponent(window.atob(payload.data)),
        //   );
        //   logger.log(
        //     `TransferReceivePage.settingController => onSettingResult : decoded : ${JSON.stringify(
        //       decoded,
        //     )} `,
        //   );
        //   if (decoded) {
        //     if (decoded.message) {
        //       reject(decoded.message);
        //       return;
        //     }
        //   }
        //   reject('설정에 실패하였습니다.');
        // }
      });

      let params = { ...settingParams, callback: 'onSettingResult' };
      const targetController = controllers.value.find(
        (item) => item._id === controllerId,
      );
      if (targetController) {
        params = {
          ...params,
          firmware_version: targetController.lastVersion,
          firmware_url: targetController.downloadUrl,
        };
      }

      logger.log(
        `TransferReceivePage.settingController => onSettingResult : params : ${JSON.stringify(
          params,
        )} `,
      );

      emitter.emit('showLoading');
      mobile.settingDevice(JSON.stringify(params));
    });
  };

  // 컨트롤러 검색 :
  const getControllerInfo = (controller) => {
    return new Promise(async (resolve, reject) => {
      try {
        logger.log(
          `TransferReceivePage.getControllerInfo => controller : ${JSON.stringify(
            controller,
          )}`,
        );

        // check controllerId
        const exControllerResult = await Axios.get(
          CtrlApi.CTRL_INFO.replace(':id', controller._id),
        );
        // if (exControllerResult.resultCode === '0000') {
        logger.log(
          `TransferReceivePage.getControllerInfo => exControllerResult : ${JSON.stringify(
            exControllerResult,
          )}`,
        );
        resolve(exControllerResult);
        return;
        // }

        // resolve(undefined);
      } catch (e) {
        console.log(e);
        logger.log(e);
        resolve('컨트롤러 추가중 오류가 발생하였습니다.');
      }
    });
  };

  const disConnectWifi = (force = false) => {
    if (force) {
      mobile.disConnectWifi(JSON.stringify({ force: 'true' }));
    } else {
      mobile.disConnectWifi(JSON.stringify(ap_wifi));
    }
  };

  // 컨트롤러 이관 :
  const requestTransferController = (
    controller,
    userId,
    srcZoneId = undefined,
    tarZoneId = undefined,
  ) => {
    return new Promise(async (resolve, reject) => {
      try {
        logger.log(
          `TransferReceivePage.requestTransferController => controller : ${JSON.stringify(
            controller,
          )}`,
        );

        const result = await Axios.patch(
          CtrlApi.TRANSFER_CTRL.replace(':id', controller._id),
          {
            id: userId,
            srcZoneId: srcZoneId,
            tarZoneId: tarZoneId,
          },
        );
        if (result.resultCode === '0000') {
          logger.log(
            `TransferReceivePage.requestTransferController => result : ${JSON.stringify(
              result,
            )}`,
          );
          resolve(result);
          return;
        }

        // reject(result.resultMessage);
        resolve(result);
      } catch (e) {
        console.log(e);
        logger.log(e);
        // reject('컨트롤러 이관 중 오류가 발생하였습니다.');
        resolve('컨트롤러 이관 중 오류가 발생하였습니다.');
      }
    });
  };

  // 컨트롤러 등록 :
  const requestRegistController = (controller, zoneId) => {
    return new Promise(async (resolve, reject) => {
      try {
        logger.log(
          `TransferReceivePage.requestRegistController => controller : ${JSON.stringify(
            controller,
          )}`,
        );

        const result = await Axios.post(
          ZoneApi.REGIST_ZONE_CTRLS.replace(':id', zoneId),
          controller,
        );
        if (result.resultCode === '0000') {
          logger.log(
            `TransferReceivePage.requestRegistController => result : ${JSON.stringify(
              result,
            )}`,
          );
          resolve(result);
          return;
        }

        // reject(result.resultMessage);
        resolve(result);
      } catch (e) {
        console.log(JSON.stringify(e));
        logger.log(e);
        // reject('컨트롤러 추가중 오류가 발생하였습니다.');
        resolve('컨트롤러 추가중 오류가 발생하였습니다.');
      }
    });
  };

  const listenChangedNetworkInfo = () => {
    return new Promise(async (resolve, reject) => {
      emitter.on('onChangedNetworkInfo', (payload) => {
        logger.log(
          'listenChangedNetworkInfo.onChangedNetworkInfo => payload : ',
          payload,
        );
        if (payload.data) {
          logger.log(
            `listenChangedNetworkInfo.onChangedNetworkInfo => payload : ${JSON.stringify(
              payload,
            )}`,
          );
          let decoded = JSON.parse(
            decodeURIComponent(window.atob(payload.data)),
          );
          logger.log(
            `listenChangedNetworkInfo.onChangedNetworkInfo => decoded : ${JSON.stringify(
              decoded,
            )}`,
          );
          if (decoded.type != 'none') {
            emitter.emit('hideLoading');
            emitter.off('onChangedNetworkInfo');
          }
          resolve('');
        }
      });

      emitter.emit('showLoading');
      setTimeout(() => {
        emitter.emit('hideLoading');
        emitter.off('onChangedNetworkInfo');
        reject('네트워크 변경에 실패했습니다.');
      }, 10000);
    });
  };

  // 컨트롤러 검색 :
  const readQRCode = () => {
    return new Promise((resolve, reject) => {
      emitter.on('onReadQRCodeResult', (payload) => {
        emitter.emit('hideLoading');
        emitter.off('onReadQRCodeResult');

        logger.log(
          `TransferReceivePage.connectWifi => readQRCode : payload : ${JSON.stringify(
            payload,
          )} `,
        );

        if (payload.result) {
          resolve(payload.data);
          return;
        }

        reject('QR코드 인식에 실패하였습니다.');
      });

      emitter.emit('showLoading');
      mobile.readQRCode(
        JSON.stringify({
          callback: 'onReadQRCodeResult',
        }),
      );
    });
  };

  // 컨트롤러 검색 :
  const showRegistView = async (visible) => {
    let timeoutId = undefined;

    return new Promise((resolve, reject) => {
      emitter.on('onShowRegistViewResult', (payload) => {
        emitter.emit('hideLoading');
        emitter.off('onShowRegistViewResult');
        clearTimeout(timeoutId);

        // mobile.disConnectWifi(true);
        console.log('onShowRegistViewResult');
        console.log(JSON.stringify(payload));
        if (payload.result) {
          resolve(true);
          return;
        }

        resolve(false);
        //reject('온도조절기 등록에 실패했습니다.');
      });

      emitter.emit('showLoading');
      mobile.showRegistView(
        JSON.stringify({
          callback: 'onShowRegistViewResult',
          visible: visible,
        }),
      );

      // timeoutId = setTimeout(() => {
      //   emitter.emit('hideLoading');
      //   emitter.off('onShowRegistViewResult');
      //   clearTimeout(timeoutId);
      //   resolve(false);
      // }, 180000);
    });
  };

  // 로컬 데이터 조회 :
  const getLocalStorage = async (key) => {
    return new Promise((resolve, reject) => {
      const callbackName = `onGetLocalStorageResult_${key}`;

      const timerId = setTimeout(() => {
        emitter.emit('hideLoading');
        reject('단말기로부터 응답이 없습니다.');
      }, 1000);

      emitter.on(callbackName, (payload) => {
        emitter.emit('hideLoading');
        emitter.off(callbackName);

        // mobile.disConnectWifi(true);
        console.log(callbackName, JSON.stringify(payload));
        if (payload.result) {
          const value = JSON.parse(
            decodeURIComponent(window.atob(payload.data)),
          );
          console.log('value:', value);
          clearTimeout(timerId);
          resolve(value);
          return;
        }

        clearTimeout(timerId);
        reject('로컬 데이터 조회에 실패했습니다.');
      });

      emitter.emit('showLoading');
      mobile.getLocalStorage(
        JSON.stringify({
          callback: callbackName,
          key: key,
        }),
      );
    });
  };

  // 로컬 데이터 저장 :
  const setLocalStorage = async (key, value) => {
    return new Promise((resolve, reject) => {
      const callbackName = `onSetLocalStorageResult_${key}`;

      const timerId = setTimeout(() => {
        emitter.emit('hideLoading');
        reject('단말기로부터 응답이 없습니다.');
      }, 1000);

      emitter.on(callbackName, (payload) => {
        emitter.emit('hideLoading');
        emitter.off(callbackName);

        // mobile.disConnectWifi(true);
        console.log(callbackName, JSON.stringify(payload));
        if (payload.result) {
          clearTimeout(timerId);
          resolve(true);
          return;
        }

        clearTimeout(timerId);
        reject('로컬 데이터 저장에 실패했습니다.');
      });

      emitter.emit('showLoading');
      mobile.setLocalStorage(
        JSON.stringify({
          callback: callbackName,
          key: key,
          value: value,
        }),
      );
    });
  };

  // BLE 어댑터 상태 확인
  const getBleAdapterState = () => {
    return new Promise((resolve, reject) => {
      emitter.on('onBleAdapterStateResult', (payload) => {
        emitter.emit('hideLoading');
        emitter.off('onBleAdapterStateResult');

        logger.log(
          `useMobile.getBleAdapterState => payload : ${JSON.stringify(payload)}`,
        );

        if (payload.result) {
          const decoded = JSON.parse(
            decodeURIComponent(window.atob(payload.data)),
          );
          resolve(decoded);
        } else {
          reject('BLE adapter state check failed');
        }
      });

      emitter.emit('showLoading');
      const ret = mobile.bleAdapterState(
        JSON.stringify({ callback: 'onBleAdapterStateResult' }),
      );
      if (ret === false) {
        emitter.emit('hideLoading');
        reject('BLE adapter state check failed');
      }
    });
  };

  // BLE 장치 스캔
  const scanBleDevices = (params = {}) => {
    return new Promise((resolve, reject) => {
      let timerId = undefined;
      let isResolved = false;

      const cleanup = () => {
        if (timerId) {
          clearTimeout(timerId);
          timerId = undefined;
        }
        emitter.off('onBleScanResult', onBleScanResult);
      };

      const onBleScanResult = (payload) => {
        if (isResolved) return;
        isResolved = true;
        cleanup();
        emitter.emit('hideLoading');

        logger.log(
          `useMobile.scanBleDevices => payload : ${JSON.stringify(payload)}`,
        );

        if (payload.result) {
          try {
            const devices = JSON.parse(
              decodeURIComponent(window.atob(payload.data)),
            );
            logger.log('BLE devices found:', devices);
            resolve(devices);
          } catch (e) {
            logger.log('Error parsing BLE scan result:', e);
            reject('BLE 스캔 결과 파싱 실패');
          }
        } else {
          const error = payload.data
            ? JSON.parse(decodeURIComponent(window.atob(payload.data)))
            : { error: 'BLE scan failed' };
          reject(error.error || 'BLE scan failed');
        }
      };

      emitter.on('onBleScanResult', onBleScanResult);

      emitter.emit('showLoading');

      // 타임아웃을 충분히 길게 설정 (스캔 시간 + 여유 시간)
      timerId = setTimeout(() => {
        if (isResolved) return;
        isResolved = true;
        cleanup();
        emitter.emit('hideLoading');
        reject('BLE 장치 스캔 시간이 초과되었습니다.');
      }, (params.timeout || 5) * 1000 + 5000); // 5초 여유 시간 추가

      const ret = mobile.bleScan(
        JSON.stringify({
          timeout: params.timeout || 5,
          filterPrefix: params.filterPrefix,
          serviceUuid: params.serviceUuid,
          callback: 'onBleScanResult',
        }),
      );
      if (ret === false) {
        if (isResolved) return;
        isResolved = true;
        cleanup();
        emitter.emit('hideLoading');
        reject('BLE scan failed');
      }
    });
  };

  // BLE 장치 연결
  const connectBleDevice = (deviceId, protoConfig = null, deviceName = null) => {
    return new Promise((resolve, reject) => {
      let timeoutId = undefined;
      let resolved = false;

      const cleanup = () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = undefined;
        }
        emitter.off('onBleConnectResult', onResult);
      };

      const onResult = (payload) => {
        if (resolved) return;
        resolved = true;
        cleanup();
        emitter.emit('hideLoading');

        logger.log(
          `useMobile.connectBleDevice => payload : ${JSON.stringify(payload)}`,
        );

        if (payload.result) {
          const decoded = JSON.parse(
            decodeURIComponent(window.atob(payload.data)),
          );
          resolve(decoded);
        } else {
          const error = payload.data
            ? JSON.parse(decodeURIComponent(window.atob(payload.data)))
            : { error: 'BLE connection failed' };
          reject(error.error || 'BLE connection failed');
        }
      };

      // 타임아웃 설정 (30초)
      timeoutId = setTimeout(() => {
        if (resolved) return;
        resolved = true;
        cleanup();
        emitter.emit('hideLoading');
        reject('BLE connection timeout (30s)');
      }, 30000);

      emitter.on('onBleConnectResult', onResult);

      emitter.emit('showLoading');
      const ret = mobile.bleConnect(
        JSON.stringify({
          deviceId: deviceId,
          deviceName: deviceName, // 스캔에서 얻은 장치 이름 전달
          protoConfig: protoConfig,
          callback: 'onBleConnectResult',
        }),
      );
      if (ret === false) {
        if (resolved) return;
        resolved = true;
        cleanup();
        emitter.emit('hideLoading');
        reject('BLE connection failed');
      }
    });
  };

  // BLE 프로비저닝 (WiFi/MQTT 설정)
  const provisionBle = (params) => {
    return new Promise((resolve, reject) => {
      let timeoutId = undefined;
      let wifiResolved = false;
      let mqttResolved = false;
      const results = { wifi: null, mqtt: null };

      // WiFi와 MQTT 모두 완료되었는지 확인하고 resolve하는 함수
      const checkAndResolve = () => {
        // WiFi와 MQTT 설정이 모두 전송되었는지 확인
        const hasWifi = params.wifi && params.wifi.ssid && params.wifi.password;
        const hasMqtt = params.mqtt && params.mqtt.url;

        // WiFi가 있으면 WiFi 완료를 기다려야 함
        // MQTT가 있으면 MQTT 완료를 기다려야 함 (WiFi 완료 후에만 전송됨)
        let shouldResolve = false;

        if (hasWifi && hasMqtt) {
          // WiFi와 MQTT 모두 있으면 둘 다 완료되어야 함
          shouldResolve = wifiResolved && mqttResolved;
        } else if (hasWifi && !hasMqtt) {
          // WiFi만 있으면 WiFi 완료 시 resolve
          shouldResolve = wifiResolved;
        } else if (!hasWifi && hasMqtt) {
          // MQTT만 있으면 MQTT 완료 시 resolve
          shouldResolve = mqttResolved;
        } else {
          // 둘 다 없으면 즉시 resolve
          shouldResolve = true;
        }

        if (shouldResolve) {
          clearTimeout(timeoutId);
          emitter.emit('hideLoading');
          emitter.off('onBleProvisionResult');
          resolve(results);
        }
      };

      emitter.on('onBleProvisionResult', (payload) => {
        logger.log(
          `useMobile.provisionBle => payload : ${JSON.stringify(payload)}`,
        );

        if (payload.result && payload.data) {
          const decoded = JSON.parse(
            decodeURIComponent(window.atob(payload.data)),
          );

          if (decoded.type === 'wifi') {
            results.wifi = decoded.status;
            wifiResolved = true;
            if (decoded.status.wifi_state || decoded.status.connected) {
              emitter.emit('setLoadingText', 'WiFi 연결 완료');
            }
            // WiFi 완료 후 MQTT 완료를 기다리므로 여기서는 resolve하지 않음
            checkAndResolve();
          } else if (decoded.type === 'mqtt') {
            results.mqtt = decoded.status;
            mqttResolved = true;
            if (decoded.status.mqtt_state || decoded.status.success) {
              emitter.emit('setLoadingText', 'MQTT 설정 완료');
            }
            // MQTT 완료 시 WiFi와 MQTT 모두 완료되었는지 확인 후 resolve
            checkAndResolve();
          } else {
            // 초기 응답
            emitter.emit('setLoadingText', '설정 전송 중...');
          }
        } else if (!payload.result) {
          const error = payload.data
            ? JSON.parse(decodeURIComponent(window.atob(payload.data)))
            : { error: 'BLE provision failed' };
          clearTimeout(timeoutId);
          emitter.emit('hideLoading');
          emitter.off('onBleProvisionResult');
          reject(error.error || 'BLE provision failed');
        }
      });

      emitter.emit('showLoading');
      emitter.emit('setLoadingText', 'BLE 프로비저닝 시작...');

      // 전체 타임아웃: WiFi 타임아웃 + MQTT 타임아웃 + 여유 시간
      const wifiTimeout = params.wifiTimeout || 10;
      const mqttTimeout = params.mqttTimeout || 10;
      timeoutId = setTimeout(() => {
        emitter.emit('hideLoading');
        emitter.off('onBleProvisionResult');
        reject('BLE 프로비저닝 시간이 초과되었습니다.');
      }, (wifiTimeout + mqttTimeout + 5) * 1000);

      const ret = mobile.bleProvision(
        JSON.stringify({
          wifi: params.wifi,
          mqtt: params.mqtt,
          protoConfig: params.protoConfig,
          wifiTimeout: wifiTimeout,
          mqttTimeout: mqttTimeout,
          callback: 'onBleProvisionResult',
        }),
      );
      if (ret === false) {
        clearTimeout(timeoutId);
        emitter.emit('hideLoading');
        reject('BLE provision failed');
      }
    });
  };

  // BLE 장치 연결 해제
  const disconnectBle = () => {
    return new Promise((resolve, reject) => {
      emitter.on('onBleDisconnectResult', (payload) => {
        emitter.emit('hideLoading');
        emitter.off('onBleDisconnectResult');

        logger.log(
          `useMobile.disconnectBle => payload : ${JSON.stringify(payload)}`,
        );

        if (payload.result) {
          resolve(true);
        } else {
          const error = payload.data
            ? JSON.parse(decodeURIComponent(window.atob(payload.data)))
            : { error: 'BLE disconnect failed' };
          reject(error.error || 'BLE disconnect failed');
        }
      });

      emitter.emit('showLoading');
      const ret = mobile.bleDisconnect(
        JSON.stringify({ callback: 'onBleDisconnectResult' }),
      );
      if (ret === false) {
        emitter.emit('hideLoading');
        reject('BLE disconnect failed');
      }
    });
  };

  // 컨트롤러 정보 조회 (HTTP)
  const getDeviceInfo = () => {
    return new Promise((resolve, reject) => {
      emitter.on('onGetDeviceInfoResult', (payload) => {
        emitter.emit('hideLoading');
        emitter.off('onGetDeviceInfoResult');

        logger.log(
          `useMobile.getDeviceInfo => payload : ${JSON.stringify(payload)}`,
        );

        if (payload.result) {
          const device = JSON.parse(
            decodeURIComponent(window.atob(payload.data)),
          );
          resolve(device);
        } else {
          const error = payload.data
            ? JSON.parse(decodeURIComponent(window.atob(payload.data)))
            : { error: 'Device info not available' };
          reject(error.message || error.error || 'Device info not available');
        }
      });

      emitter.emit('showLoading');
      const ret = mobile.getDeviceInfo(
        JSON.stringify({ callback: 'onGetDeviceInfoResult' }),
      );
      if (ret === false) {
        emitter.emit('hideLoading');
        reject('Device info request failed');
      }
    });
  };

  return {
    searchWifiList,
    getWifiInfo,
    connectWifi,
    connectTest,
    connectTempWifi,
    settingController,
    getControllerInfo,
    requestTransferController,
    requestRegistController,
    listenChangedNetworkInfo,
    disConnectWifi,
    readQRCode,
    showRegistView,
    getLocalStorage,
    setLocalStorage,
    getBleAdapterState,
    scanBleDevices,
    connectBleDevice,
    provisionBle,
    disconnectBle,
    getDeviceInfo,
  };
}
